import { render, staticRenderFns } from "./Offers.vue?vue&type=template&id=10f1e812&scoped=true&"
import script from "./Offers.vue?vue&type=script&lang=js&"
export * from "./Offers.vue?vue&type=script&lang=js&"
import style0 from "./Offers.vue?vue&type=style&index=0&id=10f1e812&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f1e812",
  null
  
)

component.options.__file = "Offers.vue"
export default component.exports